import { observer } from 'mobx-react'
import type { Instance } from 'mobx-state-tree'

import { FilterType } from 'models/common/Filters/FilterType'
import type { FilterModel } from 'models/common/Filters/FilterModel'
import { Select, DateSelect, Search } from './components'

interface TableFiltersProps {
  filters: Instance<typeof FilterModel>
  onFiltersChanged?: () => void
}

const TableFilters: React.FC<TableFiltersProps> = observer(({ filters, onFiltersChanged }) => {
  return (
    <>
      {Array.from(filters.fieldFilters, ([fieldName, fieldFilter]) => {
        switch (fieldFilter.type) {
          case FilterType.SELECT:
            return <Select {...{ key: fieldName, fieldName, fieldFilter, onFiltersChanged }} />
          case FilterType.DATE:
            return <DateSelect {...{ key: fieldName, fieldName, fieldFilter, onFiltersChanged }} />
          case FilterType.SEARCH:
            return <Search {...{ key: fieldName, fieldName, fieldFilter, onFiltersChanged }} />
          default:
            return null
        }
      })}
    </>
  )
})

export default TableFilters
